import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import { InputLabel, TextField } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { observer } from 'mobx-react';
// fontSize and fontFamily have to match between Editor and SyntaxHighlighter
var fontSize = '12px';
// Optimize by using system default fonts: https://css-tricks.com/snippets/css/font-stacks/
var fontFamily = 'Consolas, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", Monaco, "Courier New", Courier, monospace';
var useStyles = makeStyles()(function (theme) {
  return {
    error: {
      color: 'red',
      fontSize: '0.8em'
    },
    callbackEditor: {
      fontFamily: fontFamily,
      fontSize: fontSize,
      background: theme.palette.background.default,
      width: 800,
      marginTop: '16px',
      border: '1px solid rgba(0,0,0,0.42)'
    },
    callbackContainer: {
      width: '100%',
      overflowX: 'auto'
    },
    textAreaFont: {
      fontFamily: fontFamily
    }
  };
});
function JsonEditor(_ref) {
  var slot = _ref.slot;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var _useState = useState(JSON.stringify(slot.value, null, 2)),
    _useState2 = _slicedToArray(_useState, 2),
    contents = _useState2[0],
    setContents = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  useEffect(function () {
    try {
      setError(undefined);
      slot.set(JSON.parse(contents));
    } catch (e) {
      console.error({
        e: e
      });
      setError(e);
    }
  }, [contents, slot]);
  return React.createElement(React.Fragment, null, error ? React.createElement("p", {
    className: classes.error
  }, "".concat(error)) : null, React.createElement("div", {
    className: classes.callbackContainer
  }, React.createElement(InputLabel, {
    shrink: true,
    htmlFor: "json-editor"
  }, slot.name), React.createElement(TextField, {
    id: "json-editor",
    className: classes.callbackEditor,
    value: contents,
    helperText: slot.description,
    multiline: true,
    onChange: function onChange(event) {
      return setContents(event.target.value);
    },
    style: {
      background: error ? '#fdd' : undefined
    },
    InputProps: {
      classes: {
        input: classes.textAreaFont
      }
    }
  })));
}
export default observer(JsonEditor);